var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_home_outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_home_outline-2",
    "data-name": "Icon_home_outline",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.447.188a.9.9,0,0,1,1.105,0l8.1,6.263a.891.891,0,0,1,.158,1.256.9.9,0,0,1-1.263.157L9,2.028,1.453,7.864A.9.9,0,0,1,.19,7.707.891.891,0,0,1,.348,6.452Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.9,0a.9.9,0,0,1,.9.895v9.395H5.4V7.605a.9.9,0,0,1,.9-.895H8.1a.9.9,0,0,1,.9.895v2.684h3.6V1.342a.9.9,0,0,1,1.8,0v9.842a.9.9,0,0,1-.9.895H.9a.9.9,0,0,1-.9-.895V.895A.9.9,0,0,1,.9,0Z",
    transform: "translate(1.8 4.921)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.722591b5ed34df9b529803e23a4725d1.svg";
export { ForwardRef as ReactComponent };